import { Node } from '@tiptap/core'

export const ChartHeader = Node.create({
  name: 'chart_header',


  group: 'chart_meta',   // 👈 NOT 'block'
  atom: true,
  selectable: false,

  parseHTML() {
    return [{ tag: 'chart-header' }]
  },

  renderHTML() {
    return ['chart-header', {}, 'NextDayDoctor']
  },
})
